module.exports = __webpack_public_path__ + "static/media/approved.d90cbc4c.svg";